import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';

import { STATE_STATUS } from '@awp/constants';
import AwpSpinner from '@components/Common/AwpSpinner';

import { IconFunnelFilter } from '@components/awpIcons';
import { resetForecast } from '@components/WeatherForecast/ForecastFilter';

import { getWxLoadingStatus, selectAllFilteredWeatherStations, setWeatherStationId } from '@stores/weatherStationSlice';
import { selectWeatherStation, setWeatherStation } from '@stores/dataVisualizationSlice';
import WeatherStationFilterModal from './WeatherStationFilterModal';

const WeatherStationDropdown = (props) => {
  const dispatch = useDispatch();
  const { sensorTypeDisabled = false, ...rest } = props;

  const shouldDispatch = props.shouldDispatch ?? true;
  const weatherStation = shouldDispatch ? useSelector(selectWeatherStation) : props.weatherStation;
  const allWeatherStations = props.weatherStationList ?? useSelector(selectAllFilteredWeatherStations);
  const loadingState = useSelector(getWxLoadingStatus);
  const [weatherStationOptions, setWeatherStationOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const [modalShow, setModalShow] = useState(false);

  const SetCurrentWeatherStation = (option) => {
    if (shouldDispatch) {
      const weatherStation = allWeatherStations.find((x) => x.Id === option.value);
      dispatch(setWeatherStation(weatherStation));
      resetForecast(dispatch);
    }

    setSelectedOption(option);
  };

  useEffect(() => {
    const wsOptions = allWeatherStations.map((opt) => {
      return { value: opt.Id, label: opt.DropdownText };
    });

    if (props.hasDeferred) {
      wsOptions.push({ value: -1, label: 'Defer' });
    }

    setWeatherStationOptions(wsOptions);
  }, [allWeatherStations]);

  useEffect(() => {
    weatherStation
      ? setSelectedOption({ value: weatherStation.Id, label: weatherStation.DropdownText })
      : setSelectedOption(props.hasDeferred ? { value: -1, label: 'Defer' } : null);
  }, [weatherStation]);

  useEffect(() => {
    dispatch(setWeatherStationId(selectedOption?.value));
  }, [selectedOption?.value]);

  const LoadingIndicator = () => {
    return (
      <div className="legend__loading">
        <AwpSpinner />
      </div>
    );
  };

  function handleChange(selOption) {
    SetCurrentWeatherStation(selOption);
    if (props.postChange && props.postChange instanceof Function) props.postChange(selOption);
  }

  const selectStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: 'white',
      borderColor: '#adb5bd',
      color: '#494949',
    }),
    container: (styles) => ({ ...styles, width: '85%', zIndex: !props.zIndex ? '1001' : props.zIndex }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles, color: '#494949' }),
    dropdownIndicator: (styles) => ({ ...styles, color: '#797979', '&:hover': { color: '#494949' } }),
  };

  return (
    <>
      <Form.Group className={rest.className ? rest.className : 'mb-1'}>
        <Form.Label style={props.labelStyle} htmlFor={props.id || props.name}>
          <b>Weather Station</b>
        </Form.Label>
        <div className="input-group">
          <Select
            options={weatherStationOptions}
            styles={selectStyles}
            value={selectedOption && weatherStationOptions.find((option) => option.value === selectedOption?.value)}
            placeholder={'Select weather station'}
            onChange={handleChange}
            isLoading={loadingState !== STATE_STATUS.SUCCESS}
            components={{ LoadingIndicator }}
            closeMenuOnSelect={props.closeMenuOnSelect ?? true}
            isDisabled={props.isDisabled ?? false}
          />
          {!props.isDisabled ?? false ? (
            <div className="input-group-append">
              <IconFunnelFilter
                alt="Weather Station Filter"
                title="Weather Station Filter"
                style={{
                  width: '2rem',
                  height: '2rem',
                  paddingTop: '.5rem',
                  paddingLeft: '.5rem',
                  cursor: 'pointer',
                }}
                onClick={() => setModalShow(true)}
              />
            </div>
          ) : null}
        </div>
      </Form.Group>
      <WeatherStationFilterModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        sensorTypeDisabled={sensorTypeDisabled}
      />
    </>
  );
};

export default WeatherStationDropdown;
